export const getFileType = (title: string) => {
  const parts = title.split(".")
  return parts[parts.length - 1]
}
